import clsx from 'clsx';

import CardsVariant from '@shared/components/position-cluster/CardsVariant';
import ChipsVariant from '@shared/components/position-cluster/ChipsVariant';
import { POSITION_CLUSTER_CARDS } from '@shared/constants/homepage-clusters';

import Headline from '../headline/Headline';

interface PositionClusterProps {
  variant: 'cards' | 'chips';
  arrowPosition?: 'left' | 'right';
  location?: string;
  className?: string;
}

const PositionCluster = ({ variant, arrowPosition = 'left', location, className }: PositionClusterProps) => (
  <div className={clsx('mx-auto flex flex-col items-center', className)} data-testid='position-cluster-container'>
    <Headline i18nKey='widgets:positionCluster.title' subTitle='widgets:positionCluster.subtitle' showArrow arrowPosition={arrowPosition} />

    {variant === 'cards' ? <CardsVariant cards={POSITION_CLUSTER_CARDS} location={location} /> : <ChipsVariant />}
  </div>
);

export default PositionCluster;
